import { createFileRoute } from '@tanstack/react-router';

/**
 * Track Exports Route (Dynamic Module)
 * Handles both /pc/track_exports and /eb/track_exports via :module param
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/$module/track_exports')({
  // No beforeLoad - parent _protected handles auth
});
